import { Question } from '../../../types';
import { TagsField } from '../../components';

interface CurrencyQuestionConfigProps {
  question: Question;
  onEdit: (questionId: string, updates: Partial<Question>) => void;
}

export function CurrencyQuestionConfig({
  question,
  onEdit,
}: CurrencyQuestionConfigProps) {
  return (
    <div className="space-y-2">
      <TagsField
        value={question.tags || []}
        onChange={(tags) => onEdit(question.id, { tags })}
      />
    </div>
  );
}
